import WordSlide from './word-slide-premium';

function App() {
  return <WordSlide />;
}

export default App;